angular.module('impactx.list').directive('ixListSelection', function () {
    return {
        restrict: 'E',
        require: '^stTable',
        scope: false,
        templateUrl: 'shared/list/templates/listselection.tmpl.html',
        link: function (scope, element, attr, ctrl) {
            scope.$watch(ctrl.getFilteredCollection, function (val) {
                scope.$parent.filtered = (val || []);
            });
        }
    }
});
